const papersDataEdexcelAlevel = {
  mathematics: [
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM319ma0-01-que-20230607.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM329ma0-01-rms-20230817.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM339ma0-02-que-20230614.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM349ma0-02-rms-20230817.pdf',
        },
        {
          label: 'Paper 31',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM359ma0-31-que-20230621.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM369ma0-31-rms-20230817.pdf',
        },
        {
          label: 'Paper 32',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM379ma0-32-que-20230621.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EAM389ma0-32-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-01-que-20220608.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-01-rms-20220818.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-02-que-20220615.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-02-rms-20220818.pdf',
        },
        {
          label: 'Paper 31',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-31-que-20220622.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-31-rms-20220818.pdf',
        },
        {
          label: 'Paper 32',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-32-que-20220622.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9ma0-32-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_01_que_20211007.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_01_rms_20211216.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_02_que_20211014.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_02_rms_20211216.pdf',
        },
        {
          label: 'Paper 31',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_31_que_20211019.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_31_rms_20211216.pdf',
        },
        {
          label: 'Paper 32',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_32_que_20211019.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_32_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_01_que_20201008.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_01_msc_20201217.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_02_que_20201015.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_02_msc_20201217.pdf',
        },
        {
          label: 'Paper 31',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_31_que_20201020.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_31_msc_20201217.pdf',
        },
        {
          label: 'Paper 32',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_32_que_20201020.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_32_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_01_que_20190606.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_01_rms_20190815.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_02_que_20190613.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_02_rms_20190815.pdf',
        },
        {
          label: 'Paper 31',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_31_que_20190615.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_31_rms_20190815.pdf',
        },
        {
          label: 'Paper 32',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_32_que_20190615.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/9MA0_32_rms_20190815.pdf',
        },
      ],
    },
  ],
  biologyasaltersnuffield: [
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABI319bn0-01-que-20230608.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABI329bn0-01-rms-20230817.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABI339bn0-02-que-20230617.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABI349bn0-02-rms-20230817.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABI359bn0-03-que-20230622.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABI369bn0-03-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bn0-01-que-20220610.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bn0-01-rms-20220818.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bn0-02-que-20220618.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bn0-02-rms-20220818.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bn0-03-que-20220625.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bn0-03-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_01_que_20211012.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_01_rms_20211216.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_02_que_20211016.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_02_rms_20211216.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_03_que_20211020.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_03_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_01_que_20201013.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_01_msc_20201217.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_02_que_20201017.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_02_msc_20201217.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_03_que_20201021.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BN0_03_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Questionpaper-ALevelPaper1-June2019.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Markscheme-AlevelPaper1-June2019.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Questionpaper-ALevelPaper2-June2019.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/MarkScheme-AlevelPaper2-June2019.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Questionpaper-ALevelPaper3-June2019.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Markscheme-AlevelPaper3-June2019.pdf',
        },
      ],
    },
  ],
  biologyb: [
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABBI319bi0-01-que-20230608.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABBI329bi0-01-rms-20230817.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABBI339bi0-02-que-20230617.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABBI349bi0-02-rms-20230817.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABBI359bi0-03-que-20230622.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EABBI369bi0-03-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bi0-01-que-20220610.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bi0-01-rms-20220818.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bi0-02-que-20220618.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bi0-02-rms-20220818.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bi0-03-que-20220625.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9bi0-03-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_01_que_20211012.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_01_rms_20211216.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_02_que_20211016.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_02_rms_20211216.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_03_que_20211020.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_03_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_01_que_20201013.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_01_msc_20201217.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_02_que_20201017.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_02_msc_20201217.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_03_que_20201021.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9BI0_03_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Questionpaper-ALevelPaper1-June2019_0.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Markscheme-AlevelPaper1-June2019_0.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Questionpaper-ALevelPaper2-June2019_0.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Markscheme-AlevelPaper2-June2019.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Questionpaper-ALevelPaper3-June2019_0.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/Markscheme-AlevelPaper3-June2019_0.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EDACH319ch0-01-que-20230613.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EDACH329ch0-01-rms-20230817.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EDACH339ch0-02-que-20230620.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EDACH349ch0-02-rms-20230817.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EDACH359ch0-03-que-20230624.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EDACH369ch0-03-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ch0-01-que-20220614.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ch0-01-rms-20220818.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ch0-02-que-20220621.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ch0-02-rms-20220818.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ch0-03-que-20220624.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ch0-03-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_01_que_20211006.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_01_rms_20211216.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_02_que_20211013.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_02_rms_20211216.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_03_que_20211019.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_03_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_01_que_20201007.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_01_msc_20201217.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_02_que_20201014.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_02_msc_20201217.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_03_que_20201020.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_03_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_01_que_20190605.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_01_rms_20190815.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_02_que_20190612.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_02_msc_20190815.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_03_que_20190620.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9CH0_03_rms_20190815.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EAPH319ph0-01-que-20230525.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EAPH329ph0-01-rms-20230817.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EAPH339ph0-02-que-20230610.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EAPH349ph0-02-rms-20230817.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EAPH359ph0-03-que-20230616.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EAPH369ph0-03-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ph0-01-que-20220527.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ph0-01-rms-20220818.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ph0-02-que-20220611.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ph0-02-rms-20220818.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ph0-03-que-20220617.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9ph0-03-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_01_que_20211009.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_01_rms_20211216.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_02_que_20211015.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_02_rms_20211216.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_03_que_20211021.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_03_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_01_que_20201010.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_01_msc_20201217.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_02_que_20201016.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_02_msc_20201217.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_03_que_20201022.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_03_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_01_que_20190521.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_01_rms_20190815.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_02_que_20190525.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_02_rms_20190815.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_03_que_20190604.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/9PH0_03_rms_20190815.pdf',
        },
      ],
    },
  ],
};

export default papersDataEdexcelAlevel;
